import * as z from "zod";

export const setDefaultEmail = {
  name: "setDefaultEmail" as const,
  input: z.object({ email: z.string().email() }),
  output: z.object({ success: z.boolean() }),
};
